import { useEffect, useRef, useCallback } from "react"

import { useUnit } from "effector-react"
import { $wsStatus } from "@store/wsModal"

/**
 * @param wsURL {String}
 * @param onMessage {function}
 * @param onError {function}
 * @returns {[Object, function]}
 */
export function useWebSocket(wsURL, onMessage, onError) {
  const status = useUnit($wsStatus)
  const socketRef = useRef()

  useEffect(() => {
    function handleError(err) {
      onError?.(err.message)
    }

    function handleClose() {
      // setTimeout(connect, 10000)
      connection()
    }

    async function connection() {
      const socket = new WebSocket(wsURL)
      socketRef.current = socket
      socketRef.current.onopen = open
      socketRef.current.onclose = handleClose
      socketRef.current.onerror = handleError
      socketRef.current.onmessage = (msg) => onMessage(msg)
    }

    connection()

    return () => {
      socketRef.current.onopen = null
      socketRef.current.onclose = null
      socketRef.current.onmessage = null
    }
  }, [])

  const sendMessage = useCallback(
    (message) => {
      socketRef.current.send(JSON.stringify(message))
    },
    [socketRef],
  )
  return [status, sendMessage]
}
